import { type PromoValue } from './getPromoForOverlay';
import { getPromoNudge } from './getPromoNudge';
import { shippingNudge } from './getSpendMoreNudge';

export const getSpendMoreNudgeForOverlay = (
  shipping: number,
  subtotal: number,
  promo?: PromoValue,
  promoText?: string
) => {
  if (shipping) {
    return shippingNudge;
  } else if (promo && promo?.threshold > subtotal && !promoText) {
    return getPromoNudge(promo);
  }
  return '';
};
